<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_7382_36375)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.58574 22L21.4143 22L12 3.16936L2.58574 22ZM0.112653 22.4742C-0.23781 23.1752 0.271882 24 1.05554 24L22.9445 24C23.7281 24 24.2378 23.1752 23.8873 22.4742L12.9429 0.582803C12.5544 -0.194267 11.4456 -0.194268 11.0571 0.582802L0.112653 22.4742Z"
    />
    <path d="M13 8H11V16H13V8Z" />
    <path
      d="M12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_7382_36375">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>
